/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export class PartnerCredentials {
  showPassword = false;
  id = 0;
  username = "";
  password = "";
}
